/* @flow */
import * as React from 'react';

type State = {
  error: ?Error,
  errorInfo: ?Object,
};

const getInitialState = () => ({ error: null, errorInfo: null });

type ErrorBoundaryProps = {
  children: React.Element<any>,
  className?: string,
  style?: Object,
  renderFallback?: (error: Error, errorInfo: Object) => React.Element<any>,
};

export class ErrorBoundary extends React.Component {
  state: State = getInitialState();

  props: ErrorBoundaryProps;

  componentDidCatch(error: Error, errorInfo: Object) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });

    //  TODO_LOG if (process.env.NODE_ENV !== 'test') {
    //  TODO_LOG   Raven.captureException(error, { extra: { errorInfo } });
    //  TODO_LOG }
  }

  renderDefaultFallback = () => {
    const { error, errorInfo } = this.state;
    const errProps = {};

    if (this.props.style) errProps.style = this.props.style;
    if (this.props.className) errProps.className = this.props.className;

    let details = null;

    if (process.env.NODE_ENV === 'development') {
      details = (
        <details style={{ whiteSpace: 'pre-wrap' }}>
          {error && error.toString()}
          <br />
          {errorInfo && errorInfo.componentStack}
        </details>
      );
    }

    return (
      <div {...errProps}>
        <h2>Something went wrong...</h2>
        <p>We've been notified that this happened and will investigate.</p>
        {details}
      </div>
    );
  };

  render() {
    // Error path
    if (this.state.errorInfo) {
      return this.props.renderFallback
          // $FlowFixMe: Sigh... how can we convince flow that error and errorInfo are defined together?
        ? this.props.renderFallback(this.state.error, this.state.errorInfo)
        : this.renderDefaultFallback();
    }

    // Normally, just render children
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/ErrorBoundary.js